import { getStoreReceipt } from '@/api';
import ReceiptLayout from '@/components/common/ReceiptLayout';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { ReceiptSummary } from '@repo/components';
import { useQuery } from 'react-query';
import styled from 'styled-components';

const Receipt = () => {
  const { nationality, passportNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const dispatch = useAppDispatch();
  const { data = [] } = useQuery(['getStoreReceipt'], () =>
    getStoreReceipt({
      passportNumber,
      latest: true,
      refundAfter: true,
    }),
  );

  const onOpenPreview = (index: number) => {
    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: {
        type: 'PREVIEW_RECEIPT',
        isActive: true,
        data: { data: { data, selectedRefund: index } },
      },
    });
  };

  return (
    <ReceiptLayout>
      <Title>
        {nationality === 'KOR'
          ? 'Tax refund 영수증'
          : nationality === 'CHN'
            ? 'Tax refund 发票'
            : 'Tax refund Receipt'}
      </Title>
      <SubTitle>
        {nationality === 'KOR'
          ? '세관을 방문하여 모바일 Tax refund 영수증과 구매한 물건을 세관 직원에게 보여주세요.'
          : nationality === 'CHN'
            ? '访问海关后，请按下端按钮向职员出示税金收据和购买物品。'
            : 'Press the blue button to show the receipt to the customs officer.'}
      </SubTitle>
      <ReceiptListWrapper>
        {data.map((receipt, index) => {
          const dateOfPurchase = receipt?.saleDate.split(' ')[0] || '-';
          const payment = Number(receipt?.totalAmount).toLocaleString() || '0';
          const refund = Number(receipt?.totalRefund).toLocaleString() || '0';

          return (
            <ReceiptSummary
              key={index}
              nationality={nationality}
              refundIndex={receipt.refundIndex}
              dateOfPurchase={dateOfPurchase}
              payment={payment}
              refund={refund}
              franchiseeName={receipt.franchiseeName || '-'}
              btnTitle={nationality === 'KOR' ? '영수증 보기' : 'View Receipt'}
              onClick={() => onOpenPreview(index)}
            />
          );
        })}
      </ReceiptListWrapper>
    </ReceiptLayout>
  );
};

export default Receipt;

const Title = styled.strong`
  width: 100%;
  margin: 18px 0 8px;
  color: #3a3b3e;
  text-align: left;
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
`;

const SubTitle = styled.p`
  margin-bottom: 24px;
  color: #80848a;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
`;

const ReceiptListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
